import AxiosInstance from '../../config/AxiosInstance';

interface AccountDetails {
  firstName: string;
  lastName: string;
  // Always sent: an older API reads only fullName.
  fullName: string;
  email: string;
  password: string;
}

interface CompanyDetails {
  companyName: string;
  companyNo: string;
  countryId: string;
}

interface SignupPayload {
  accountDetails: AccountDetails;
  companyDetails: CompanyDetails;
}


export const signup = async (payload: SignupPayload) => {
  try {
    const { data } = await AxiosInstance.post('/api/signup', payload);
    return { data };
  } catch (error) {
    throw error;
  }
};